import { StaffClass } from "../../staff/models/staff";
import { SectorClass } from "../../sectors/models/sector";

export const OfficeContentSections =  {
    role: "Competenze",
    sectors: "Settore di riferimento",
    staff: "Componenti",
    contacts: "Contatti",
    services: "Servizi",
    documents: "Documenti",
    more_info: "Ulteriori informazioni"
}

export class OfficeClass {    
  
    constructor(data){
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
        this.content = data.content;
        this.last_update = data.last_update;
        this.staff = data.staff_data?.map((staff) => new StaffClass(staff)) || [];
        this.sectors = data.sectors_data?.map((sector) => new SectorClass(sector)) || [];
        this.reception_hours = data.reception_hours;
        this.appointment_duration = data.appointment_duration;
        this.referent = data.referent;
    }
}